import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    BASE_TEXT_PX,
    PRIMARY_FONT_COLOR,
    DARK_NAVY_FONT_COLOR,
    FONT_FAMILY_DEMI,
    FONT_FAMILY_REGULAR,
    GRAY_FONT_COLOR,
    X_LARGE_TEXT_PX,
    TITLE_FONT_COLOR,
    LARGE_TEXT_PX,
    SECONDARY_FONT_COLOR,
    SEMANTIC_TEXT_PX,
    SEMANTIC_TEXT_SMALL_PX,
    SMALL_TEXT_PX,
    X_SMALL_TEXT_PX,
} from 'src/styles/fonts/MCFontConstants';

export const SetsInventoryContainer = styled.section`
    padding: ${({ hasBanner }) => (hasBanner ? '8px 0 0' : '8px 10px 24px 0px')};
    color: #140f4b;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
    padding: ${({isMobileView}) => isMobileView ? '8px 0px 24px 0px' : '8px 10px 24px 0px'};
    padding-bottom: ${({ hasBanner }) => (hasBanner ? '0px' : '25px')};

    ${media.mobileDevice`
        display: flex;
        flex: 1 1 auto;
        min-height: 0;
        gap: 0px;
        overflow-y: auto;
        overflow-x: hidden;
        -webkit-overflow-scrolling: touch;
    `}
`;

export const SearchPanel = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.08);
    padding: 14px 18px;
    margin: 8px 0 10px;

    ${media.mobileDevice`
        align-items: flex-start;
        flex-direction: column;
        padding: 14px;
    `}
`;

export const SearchLabel = styled.div`
    font-family: 'AvenirNextWorld Demi';
    font-size: 18px;
    color: #140f4b;
`;

export const SearchControls = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;

    ${media.mobileDevice`
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    `}
`;

// export const ResultsHeaderRow = styled.div`
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     margin: 8px 5px 10px;

//     ${media.mobileDevice`
//         flex-direction: row;
//         align-items: center;
//         justify-content: space-between;
//         gap: 10px;
//     `}
// `;

export const ResultsLeft = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    flex: 1;
    min-width: 0;
`;

export const ResultsCount = styled.div`
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${LARGE_TEXT_PX};
    color: #140f4b;
    white-space: nowrap;
    flex: 0 0 auto;
    width: fit-content;
    max-width: 100%;
    
    
    ${media.mobileDevice`
        font-size: ${BASE_TEXT_PX};
        // width: 100%!important;
    `}
`;

export const DesktopFilterPanelWrapper = styled.div`
    display: flex;
    align-items: center;
    min-width: 0;

    .MuiGrid-root.MuiGrid-container {
        align-items: center;
        flex-wrap: nowrap;
        justify-content: flex-start;
    }

    .MuiGrid-root.MuiGrid-item {
        max-width: none;
        width: auto;
    }

    .MuiGrid-root.MuiGrid-item:first-child {
        flex: 0 1 auto;
        min-width: 0;
    }

    .MuiGrid-root.MuiGrid-item:last-child {
        background-color: transparent !important;
        flex: 0 0 auto;
        margin-left: 8px;
    }

    ${media.mobileDevice`
        display: none;
    `}
`;

export const MobileFilterPanelWrapper = styled.div`
    display: none;

    ${media.mobileDevice`
        display: block;
        width: 100%;
        margin-top: -5px;

        .MuiGrid-root.MuiGrid-container {
            align-items: center;
            flex-wrap: nowrap;
            justify-content: space-between;
            width: 100%;
        }

        .MuiGrid-root.MuiGrid-item {
            max-width: none;
        }

        .MuiGrid-root.MuiGrid-item:first-child {
            flex: 1 1 auto;
            min-width: 0;
        }

        .MuiGrid-root.MuiGrid-item:last-child {
            background-color: transparent !important;
            flex: 0 0 auto;
            margin-left: 8px;
            text-align: right;
        }
    `}
`;

export const ResultsView = styled.span`
    margin-left: 10px;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    color: #302c63;

    span {
        font-family: 'AvenirNextWorld Regular';
        color: #6a668a;
        margin-right: 5px;
    }
`;

// export const ResultsActions = styled.div`
//     display: flex;
//     align-items: center;
//     gap: 8px;
// `;

export const ResultsRight = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    justify-content: flex-end;
    gap: 8px;

    ${media.mobileDevice`
        width: 100%;
        max-width: 98%;
        justify-content: flex-end;
        padding-top: 4px;
    `}
`;

export const ExportIconImg = styled.img`
    width: 12px;
    height: 12px;
    margin-right: 5px;
`;

export const ExportSpinnerWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const TableCard = styled.div`
    background: transparent;
    display: flex;
    flex: ${({ $isFullPage }) => ($isFullPage ? '1' : '0 1 auto')};
    flex-direction: column;
    margin: 0 5px;
    min-height: 0;
    overflow: visible;
    position: relative;
    width: calc(100% - 10px);

    > div,
    > div > div,
    .p-datatable {
        display: flex;
        flex-direction: column;
        height: 100%;
        min-height: 0;
    }

    && .p-datatable.p-datatable-responsive .p-datatable-thead > tr > th,
    && .p-datatable-scrollable-header .p-datatable-thead > tr > th,
    && .p-datatable-scrollable-header table thead > tr > th {
        border-bottom: 1px solid #dcdcdc !important;
        font-family: ${FONT_FAMILY_DEMI} !important;
        font-size: ${SMALL_TEXT_PX} !important;
        height: 55px !important;
        min-height: 60px !important;
        padding: 0 !important;
        line-height: 20px;
        vertical-align: middle;
        padding-left: 16px !important;
        text-align: left !important;
    }

    && .p-datatable .p-sortable-column .p-column-title,
    && .p-datatable .p-sortable-disabled .p-column-title {
        color: ${GRAY_FONT_COLOR} !important;
        font-family: ${FONT_FAMILY_DEMI} !important;
        font-size: ${SMALL_TEXT_PX} !important;
    }

    && .p-datatable .p-sortable-column .p-sortable-column-icon {
        margin-left: 2px !important;
    }

    .p-datatable-scrollable-header {
        background: #ffffff;
    }

    .p-datatable-scrollable-header-box {
        box-sizing: border-box;
        width: 100% !important;
    }

    .p-datatable-scrollable-wrapper {
        background: #ffffff;
        border: 1px solid #dcdcdc;
        border-radius: 6px;
        box-shadow: 0px 0px 6px #00000029;
        overflow: hidden;
    }

    .p-datatable-scrollable-wrapper,
    .p-datatable-scrollable-view,
    .p-datatable-scrollable-table-wrapper {
        display: flex;
        flex: 1;
        flex-direction: column;
        min-height: 0;
    }

    .p-datatable-scrollable-body {
        flex: 1;
        min-height: 0;
        max-height: none !important;
        overflow-x: hidden !important;
        overflow-y: scroll !important;
        padding-bottom: 8px;
    }

    .p-datatable-scrollable-body::-webkit-scrollbar {
        display: block !important;
        width: 10px;
    }

    .p-datatable-thead > tr > th:nth-child(5),
    .p-datatable-tbody > tr > td:nth-child(5) {
        padding-right: 8px !important;
    }

    .p-datatable table {
        table-layout: fixed;
    }

    @media (min-width: 768px) and (max-width: 1280px) {
        .p-datatable-thead > tr > th:nth-child(1),
        .p-datatable-tbody > tr > td:nth-child(1) {
            width: 27% !important;
        }

        .p-datatable-thead > tr > th:nth-child(4),
        .p-datatable-tbody > tr > td:nth-child(4) {
            width: 21% !important;
            padding-right: 28px !important;
        }

        .p-datatable-thead > tr > th:nth-child(5),
        .p-datatable-tbody > tr > td:nth-child(5) {
            width: 14% !important;
        }
    }

    .p-datatable .p-paginator-bottom {
        flex-shrink: 0;
        margin-top: 12px;
        background: #ffffff;
        box-shadow: 0px 0px 6px #00000029;
        border: 1px solid #dcdcdc;
        border-radius: 8px;
        min-height: 58px;
        display: flex;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        .p-datatable .p-paginator-bottom {
            position: sticky;
            bottom: 0;
            z-index: 100;
        }
    }
`;

export const TableCellContent = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    line-height: 18px;
    color: ${PRIMARY_FONT_COLOR};
`;

export const SetNumber = styled.div`
    color: ${({ $isTableSetNumber }) =>
        $isTableSetNumber ? TITLE_FONT_COLOR : '#1021eb'};
    font-family: ${FONT_FAMILY_DEMI};
    font-size: ${({ $isTableSetNumber }) =>
        $isTableSetNumber ? BASE_TEXT_PX : SMALL_TEXT_PX};
    line-height: ${({ $isTableSetNumber }) =>
        $isTableSetNumber ? X_LARGE_TEXT_PX : 'normal'};
    letter-spacing: 0;
    margin-bottom: 3px;
`;

export const Description = styled.div`
    color: ${({ $isTableDescription }) =>
        $isTableDescription ? PRIMARY_FONT_COLOR : 'inherit'};
    font-style: normal;
    font-weight: ${({ $isTableDescription }) =>
        $isTableDescription ? 400 : 'inherit'};
    font-size: ${({ $isTableDescription }) =>
        $isTableDescription ? SMALL_TEXT_PX : 'inherit'};
    line-height: ${({ $isTableDescription }) =>
        $isTableDescription ? X_LARGE_TEXT_PX : 'inherit'};
    font-family: ${({ $isTableDescription }) =>
        $isTableDescription ? FONT_FAMILY_REGULAR : 'inherit'};
    max-width: 290px;
`;

export const StrongLabel = styled.span`
    font-family: ${FONT_FAMILY_DEMI};
    color: #333333;
`;

export const ViewSetAction = styled.div`
    display: flex;
    justify-content: flex-end;
    text-align: right;
`;

/* ── Mobile card list ─────────────────────────────────────────────── */

export const MobileTableCard = styled.div`
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    overflow: hidden;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const MobileSortRow = styled.div`
    padding: 0;
    display: flex;
    align-items: center;
    gap: 8px;

    ${media.mobileDevice`
        margin: 8px 0px 8px 0px;
    `}
`;

export const MobileSortIcon = styled.img`
    width: 14px;
    height: 14px;
`;

export const SetCardList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;

    ${media.mobileDevice`
        padding-bottom: 76px;
    `}
`;

export const SetCard = styled.div`
    background: #ffffff;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    padding: 14px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    box-shadow: 0 3px 3px -2px rgba(0, 0, 0, 0.20), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 1px 8px 0 rgba(0, 0, 0, 0.12);
`;

export const SetCardBody = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-family: ${FONT_FAMILY_REGULAR};
    font-size: ${SMALL_TEXT_PX};
    line-height: 18px;
    color: #140f4b;
`;

export const SetCardSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const SetCardAction = styled.button`
    background: #ffffff;
    border: 1px solid #1021eb;
    border-radius: 6px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;

    img {
        width: 20px;
        height: 20px;
    }
`;

export const MobilePaginationWrapper = styled.div`
    ${media.mediumDevice`
        position: relative;
    `}
    ${media.mobileDevice`
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        z-index: 10;
        background-color: #ffffff;
        padding: 0px 0px 12px 0;
        margin: 0;
        box-shadow: 0px -2px 6px rgba(0, 0, 0, 0.1);
    `}
`;

export const EmptyResultsMessage = styled.div`
    text-align: start;
    padding: 0px 10px 0px 10px;
    color: ${SECONDARY_FONT_COLOR};
    font-size: ${SMALL_TEXT_PX};
    font-family: ${FONT_FAMILY_REGULAR};
    ${media.mobileDevice`
        padding: 10px;
    `}
`;

export const SubContent = styled.div`
    font-family: ${FONT_FAMILY_REGULAR};

    ${Description} + & {
        margin: 5px 0 0 0;
    }

    & + & {
        margin: 5px 0 0 0;
    }
`;

export const SetBatchLink = styled.a`
  font-weight: 600;
  color: ${TITLE_FONT_COLOR};
  font-size: ${SMALL_TEXT_PX};
  font-family: ${FONT_FAMILY_DEMI};
  text-decoration: none;
  cursor: pointer;
  
      ${media.smalDevice`
        font-size: 11px;
      `}
      
      ${media.mobileDevice`
        font-size: ${SMALL_TEXT_PX};
      `}
`;

/* ---- Combined Search and Results Section ---- */
export const SearchAndResultsCard = styled.div`
    display: flex;
    flex-direction: column;
    background: transparent;
    border-radius: 0;
    padding: 0;
    gap: 12px;
    box-shadow: 0px 0px 6px #00000029 !important;
    
    ${media.mobileDevice`
        background: #ffffff;
        border-radius: 0;
        box-shadow: none;
        padding: 8px 16px 12px 16px;
        gap: 8px;
        
        /* Remove nested card styling from SearchAndFilterContainer in mobile view only */
        > div:first-child {
            background: transparent !important;
            box-shadow: none !important;
            border-radius: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            width: 100% !important;
        }
    `}
`;

export const ResultsActions = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-shrink: 0;
    justify-content: flex-end;
    gap: 8px;
    ${media.mobileDevice`
        width: 100%;
        max-width: 100%;
        justify-content: flex-end;
        padding-top: 4px;
    `}
`;

/* ---- Results header (mirrors FIM FilterRow) ---- */
export const ResultsHeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    gap: 8px;
    // width: 100%;
    // margin: 0px 5px;
    margin: 0;
    padding: 0px 10px 0px 10px;
    ${media.mobileDevice`
        flex-direction: column;
        align-items: flex-start;
        padding: 0;
        gap: 0px;
    `}
`;

export const MobileTableContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    box-sizing: border-box;
    padding: 0px 16px 24px 16px;
`;